module.exports = __webpack_public_path__ + "static/media/no-product-image.dbb4efbc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/no-product-image.png
// module id = 56
// module chunks = 0